<template>
  <ValidationObserver v-slot="v" ref="observer">
    <div>
      <b-modal @hide="hideModal(false)" :visible="show" :no-close-on-backdrop="loading" :no-close-on-esc="loading"
               :header-bg-variant="variant">
        <template v-slot:modal-header>
          <h5 class="modal-title" :style="titleStyle">
            {{ title }}
          </h5>
          <button type="button" :disabled="loading" @click="hideModal(false)" aria-label="Close" class="close">×
          </button>

        </template>

        <template v-slot:modal-footer>
          <cancel-button :text="cancelBtnText" @click="hideModal(false)"/>
          <submit-button variant="danger" :text="submitBtnText" :disabled="v.pending || v.invalid" :show-loader="loading"

                         @click="onSubmitClick"/>
        </template>

        <span v-html="message"/>
        <ValidationProvider :name="`textarea-confirm-dialog`" :rules="commentRules ? commentRules : ''" v-slot="v"
                            tag="div" ref="currentObserver">
          <b-form-group :class="{'has-error': getState(v) === false, 'has-success': getState(v) === true, 'mt-2': true}">
            <b-form-textarea ref="currentInput" type="textarea" :name="`textarea-confirm-dialog`"
                             :key="`textarea-confirm-dialog`" v-model="comment"
                             :placeholder="commentLabel" :rows="5"/>
            <b-form-invalid-feedback :state="getState(v)">
              {{ getError(v.errors) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-modal>
    </div>
  </ValidationObserver>
</template>

<script>
import CancelButton from "../../core/components/common/CancelButton";
import SubmitButton from "../../core/components/common/SubmitButton";
import EventBus from "../event-bus";
import {
  ON_CONFIRM_WITH_COMMENT_DIALOG_OPEN, ON_CONFIRM_WITH_COMMENT_DIALOG_HIDE
} from "../event-bus/event-bus-names";

export default {
  name: "ConfirmWithCommentModal",
  components: {SubmitButton, CancelButton},
  computed: {
    titleStyle() {
      if (this.variant === 'danger') return {color: 'white'}
    }
  },
  data() {
    return {
      loading: false,
      show: false,
      message: null,
      title: null,
      submitBtnText: null,
      cancelBtnText: null,
      commentLabel: null,
      commentRules: null,
      variant: null,
      comment: ''
    }
  },
  methods: {
    getMessageHTML(message) {
      // If given message is array, convert it to Unordered List
      if (Array.isArray(message) && message.length > 0) {
        if (message.length === 1) {
          message = message[0]
        } else {
          let list = document.createElement('ul')
          message.forEach((s) => {
            let item = document.createElement('li')
            item.appendChild(document.createTextNode(s))
            list.appendChild(item)
          })
          return list.innerHTML
        }
      }
      return message
    },
    hideModal(param) {
      EventBus.$emit(ON_CONFIRM_WITH_COMMENT_DIALOG_HIDE, param);
      this.clearParams();
    },
    clearParams() {
      this.message = null;
      this.loading = false;
      this.title = null;
      this.show = false;
      this.submitBtnText = null;
      this.cancelBtnText = null;
      this.commentLabel = null;
      this.commentRules = null;
      this.variant = null;
      this.comment = null;
    },
    async onSubmitClick(_) {
      this.hideModal({success: true, comment: this.comment});
    },
    getError(errors) {
      return errors.length ? errors[0] : null;
    },
    getState(validator) {
        if (validator.errors['textarea-confirm-dialog'] && validator.errors['textarea-confirm-dialog'].length) {
          return false;
        }

        // Validate is set when validate function of vee validate is run
        if (validator.validated === true) {
          // return validator.valid;
          return validator.valid === true ? null : false;
        }

        if (!validator.touched) {
          return null;
        }
        return validator.valid === true ? null : false;
      },
  },
  beforeMount() {
    EventBus.$on(ON_CONFIRM_WITH_COMMENT_DIALOG_OPEN, ({
                                                         message,
                                                         title,
                                                         submitBtnText,
                                                         cancelBtnText,
                                                         commentLabel,
                                                         commentRules,
                                                         variant
                                                       }) => {
      this.clearParams();
      this.message = this.getMessageHTML(message);
      this.title = title;
      this.show = true;
      this.submitBtnText = submitBtnText;
      this.cancelBtnText = cancelBtnText;
      this.commentLabel = commentLabel;
      this.commentRules = commentRules;
      this.variant = variant

    });
  },
  beforeDestroy() {
    EventBus.$off(ON_CONFIRM_WITH_COMMENT_DIALOG_OPEN);
  }
}
</script>

<style scoped>

</style>
